<template>
	<div id="label" class="label">
		<nav class="navbar navbar-light bg-light">
			<div class="form-inline">
				<input class="form-control form-control-sm mr-sm-1" type="search" placeholder="Buscar" aria-label="Buscar" v-model="searchLabels" v-on:keyup.enter="getAllLabels(1)">
				<button class="btn btn-sm btn-outline-info my-2 my-sm-1" type="submit" @click="getAllLabels(1)">Buscar</button>
			</div>
			<div class="form-inline">
				<span class="mr-sm-1">Mostrar</span>
				<select class="form-control form-control-sm mr-sm-1 float-sm-right" id="qrows" v-model="qRowsLabel" @change="getAllLabels(1)">
					<option value="10">10</option>
					<option value="25">25</option>
					<option value="50">50</option>
					<option value="100">100</option>
					<option value="200">200</option>
					<option value="1000">1000</option>
			    </select>
				<span class="mr-sm-1">Registros</span>
			</div>
		</nav>

		<table class="table table-sm table-hover">
			<thead>
				<tr class="text-center">
					<th>Id</th>
					<th>Nombre</th>
					<th class="text-center">Fecha de modificación</th>
					<th class="text-center">Estado</th>
					<th class="text-right">
						<i class="fas fa-plus-circle text-primary pointer" @click="newLabel"></i>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr v-if="searchingLabels">
					<td colspan="6" class="text-center"><img src="@/assets/search-color.gif" width="32px"/> Buscando etiquetas . . .</td>
				</tr>
				<tr v-for="(item, index) in listLabels" :key="index">
					<td>{{ item.id }}</td>
					<td>{{ item.name }}</td>
					<td class="text-center">{{ item.updated_at }}</td>
					<td class="text-center">{{ item.status }}</td>
					<td class="text-right">
						<i class="far fa-edit pointer text-warning margin-right5" @click="openLabelModal(index)"></i>
						<i class="fas fa-trash-alt text-danger margin-right5 pointer margin-right5" @click="deleteLabel(item.id)"></i>
					</td>
				</tr>
			</tbody>
		</table>
		<pagination :pagination="paginationLabels" @getAllList="getAllLabels"></pagination>

		<div class="modal fade" id="labelModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="labelModalLabel">Etiqueta <b>{{ (objectLabel.id == 0) ? 'Nueva' : objectLabel.name }}</b></h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="form-group">
							<label for="labelName">Nombre</label>
							<input type="text" class="form-control" id="labelName" aria-describedby="labelName" v-model="objectLabel.name">
						</div>
						<div class="form-group">
							<label for="labelZPL">Codigo ZPL</label>
							<textarea class="form-control" id="labelZPL" rows="10" v-model="objectLabel.zpl"></textarea>
						</div>
						<div class="form-group row">
							<label for="labelStatusId" class="col-sm-2 col-form-label">Estado</label>
							<div class="col-sm-4">
								<select class="form-control" v-model="objectLabel.status_id" id="labelStatusId">
									<option v-for="(item, index) in listStatus" :key="index" :value="item.id">{{ item.name }}</option>
								</select>
							</div>
						</div>
						<div class="form-group">
							<label for="labelName">Variables</label>
							<p>
								<span v-for="(item, index) in listVariables" :key="index" class="badge badge-dark margin-right5">{{ item.name }}</span>
							</p>
						</div>
						<hr>
						<div class="form-group row">
							<label for="listPrinter" class="col-sm-2 col-form-label">Impresoras</label>
							<div class="col-sm-4">
								<select class="form-control" v-model="indexSelectedPrinterWebSocketServer" @change="changeSelectedPrinterWebSocketServer">
									<option v-for="(item, index) in listPrinterWebSocketServer" :key="index" :value="index">{{ item }}</option>
								</select>
							</div>
							<button type="button" class="btn btn-default" @click="toPrintTest">Imprimir</button>
						</div>
					</div>					
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-toggle="modal" data-target="#labelModal" ref="openLabelModal" v-show="1==2">Abrir</button>
						<button type="button" class="btn btn-secondary" data-dismiss="modal" ref="closeLabelModal">Cerrar</button>
						<button type="button" class="btn btn-primary" @click="saveLabel()">Guardar cambios</button>
					</div>
				</div>
			</div>
		</div>


		<div class="modal fade" id="labelVariablesModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLabel">Datos de prueba</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="form-group row" v-for="(item, index) in listVariablesF" :key="index">
							<label :for="'listVariables' + index" class="col-sm-5 col-form-label">{{ item.name }}</label>
							<div class="col-sm-7">
								<input type="text" class="form-control form-control-sm" v-model="item.val" :id="'listVariables' + index">
							</div>
						</div>
						<div class="form-group row">
							<label for="quantity0" class="col-sm-5 col-form-label">Cantidad</label>
							<div class="col-sm-7">
								<input type="text" class="form-control form-control-sm" v-model="quantity" id="quantity0">
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
						<button type="button" class="btn btn-secondary" data-dismiss="modal" @click="toPrintWithVariables">Imprimir</button>
						<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#labelVariablesModal" ref="openLabelVariablesModal" v-show="1==2">Abrir</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import mixin from "@/mixins"
import errors from "@/mixins/errors.js"
import axiosAction from "@/mixins/axiosAction.js"
import status from "@/mixins/status"
import label from "@/mixins/labels/"
import webSocketServer from '@/mixins/webSocketServer.js'

import Pagination from '@/components/Pagination.vue'

export default {
	name: "Label",
	mixins: [axiosAction, errors, mixin, webSocketServer, status, label],
	data() {
		return {};
	},
	components: {
		'pagination': Pagination,
	},
	methods: {
		getAllStatusResultLocal(response) {},
		initModuleLocal() {
			this.setTitleModule("Modulo de Etiquetas");
			this.setSubTitleModule("");
			this.typeStatusId = 1
			this.getAllStatus()
			this.getAllLabels()
		},
		newLabel() {
			this.clearObjectLabel()
			this.$refs.openLabelModal.click()
		},
		openLabelModal(index) {
			this.selectedLabel(index)
			this.$refs.openLabelModal.click()
		},
		resultAxiosLocal(responseLocal, response) {
			switch (responseLocal) {
				case "resultSaveLabelPOST":
					this.$refs.closeLabelModal.click()
				case "resultSaveLabelPUT":
					this.$refs.closeLabelModal.click()
				case "resultDeleteLabel":
				case "resultGetAllLabels":
					this.resultAxiosLocalLabel(responseLocal, response);
					break;
				case "getAllStatusResult":
					this.getAllStatusResult(response);
					break;
				default:
					console.log("Acción no determinada despues de la consulta (" + responseLocal +")");
					break;
			}
			this.$emit("hideLockScreen");
		},
	},
	mounted() {
		this.initModule();
	},
};
</script>

<style scoped lang="scss">
</style>